const TYPES = {
	SET_SOCIAL: 'SET_SOCIAL',
	SET_CONTACT: 'SET_CONTACT',
	GET_SOCIAL: 'GET_SOCIAL',
	GET_CONTACT: 'GET_CONTACT',
};

export default TYPES;
